
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.74 13.086c-.56 0-1.778-.71-2.743-1.27-.61-.355-1.22-.71-1.372-.71-.253 0-.253 0-.355.101-.05.051-.203.153-.457.305-.559.406-1.27.66-1.27.66-.05 0-.762-.304-1.32-.66-.254-.152-.356-.254-.406-.305-.102-.101-.102-.101-.356-.101-.152 0-.762.355-1.371.71-.965.56-2.184 1.27-2.743 1.27C.433 13.036.23 12.58.18 12.58v-.051L7.442 1.965l.05-.051s.051 0 .051.05l7.263 10.564v.05c.101 0-.153.508-1.067.508.05 0 0 0 0 0z"}})])
          )
        }
      }
    